import React from 'react';
import { Box } from '@chakra-ui/react';

export default function CardHeader(props) {
  return (
    <Box className="card-header" borderTopRadius="md" fontWeight="bold" textAlign="center" py={2} userSelect="none">
      {props.children}
    </Box>
  );
}
